import React, { useEffect, useState } from 'react';
import { Input, Radio,NumberPicker   } from '@alifd/next';
import styles from './index.module.scss';
import TopTitle from '@/components/UI/TopTitle';

const WIDTH = window.screen.width; //获取屏幕宽度
/**
 * @param tagData 人群类型数据
 * @param chooseTag 修改人群类型数据
 * @param checkType 1新建2复制3查看
 */
const ChoosePeopleType = (props) => {
  return (
    <div style={{ marginBottom: '20px', background: 'white', padding: '20px', borderRadius: '5px' }}>
      <TopTitle title='复购周期录入'/>
      <div>
        <div className={styles.baseInfoContent}>
          <div className={styles['title-box']}>复购周期录入方式：</div>
          <div className={styles['radio-box']}>
            <Radio id="now" checked={props.params.viewButton.firstHalf[0].select} disabled={+props.checkType === 3} className={styles.rightNow} style={{marginRight:'30px'}} onClick={(v)=>{
              let temp = {...props.params}
              temp.viewButton.firstHalf[0].select = true
              temp.viewButton.firstHalf[1].select = false
              props.setBaseInfo(temp)
            }}>按商品分组录入</Radio>
            <Radio id="setTime" checked={props.params.viewButton.firstHalf[1].select} disabled={+props.checkType === 3} onClick={(v)=>{
              let temp = {...props.params}
              temp.viewButton.firstHalf[0].select = false
              temp.viewButton.firstHalf[1].select = true
              props.setBaseInfo(temp)
            }}>按SKU线录入</Radio>
          </div>
        </div>
        <div className={styles['record-box']}>
          { props.forSku.length !== 0 && 
            <div style={{left:+props.params.viewButton.firstHalf[0].select ?'56px':'193px'}} className={styles['up-arrow1']}/>
          }
          {
            props.forSku.length === 0 ?
              <div className={styles['please-choose-tips-box']}>
                请先选择商品分组
              </div>
            :
            +props.params.viewButton.firstHalf[0].select ?
              <div className={styles['goods-line-input-box']}>
                {
                  props.params.viewButton.secondHalf.addParam.productLineList.map((item,index)=>{
                    return (
                      <div key={index}>
                        <div style={{display:'flex'}}>
                          <span className={styles.red} style={{marginRight:"5px"}}>*</span><span style={{maxWidth:"120px"}} className={styles.emit1}>{item.name}</span><span>复购周期：</span>
                        </div>
                        <div className={styles['goods-line-input-box-input']}>
                          <NumberPicker min={1} max={720} style={{width:"526px",marginRight:"5px"}} disabled={+props.checkType === 3} value={item.day} onChange={(v)=>{
                            let temp = {...props.params}
                            temp.viewButton.secondHalf.addParam.productLineList[index].day = v
                            let tempLine = [...props.forLine]

                            tempLine.forEach((line,lindex)=>{
                              if(line.productId === item.productId){
                                tempLine[lindex].day = v
                              }
                            })
                            props.setForLine(tempLine)
                            props.setBaseInfo(temp)
                          }}/>
                          <span className={styles['grey-text']}>天</span>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            :
            +props.params.viewButton.firstHalf[1].select ?
            <div className={styles['sku-line-input-box']}>
              {
                props.forSku.map((item,index)=>{
                  return (
                    <div className={styles['sku-info-box']} key={index}>
                      <img src={item.imagePath} alt="" className={styles['goods-img']}/>
                      <div>
                        <div className={styles['goods-name']}>{item.name}</div>
                        <div className={styles['goods-sku-box']}>
                          <div className={styles['goods-sku']}>skuID:{item.skuId}</div>
                          <div style={{ lineHeight: "30px" }}>
                            <span className={styles.red}>*</span>复购周期：
                            <NumberPicker 
                              disabled={+props.checkType === 3} 
                              value={props.forSku[index].day} 
                              min={1} max={720} 
                              size="medium" 
                              style={{ width: "78px", marginRight: "5px" }} 
                              onChange={(v) => {
                                let temp = [...props.forSku]
                                temp[index].day = v
                                props.setForSku(temp)
                              }}
                            />
                            天
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
            :
            ''
          }
        </div>
        <div className={styles['tips-box']}>
          注：基于不同商品的复购周期，通过计算客户最后一次购买的时间和商品数量，预测客户下一次购买时间。
          </div>
      </div>
    </div>
  )
}

export default ChoosePeopleType;
